"use strict";

exports.__esModule = true;
exports.getKeys = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getKeys = function getKeys(IDs, userVisible) {
  var keysMetaData = Object.values(IDs).reduce(function (acc, val) {
    var _objectSpread2;

    return _objectSpread({}, acc, (_objectSpread2 = {}, _objectSpread2[val] = {
      userVisibility: userVisible.includes(val)
    }, _objectSpread2));
  }, {});
  return Object.values(IDs).map(function (key) {
    return _objectSpread({
      key: key
    }, keysMetaData[key]);
  });
};

exports.getKeys = getKeys;